import LoginRequired from '../../components/redeem/LoginRequired';
import PropTypes from 'prop-types';
import React from 'react';
import RedeemActions from '../../actions/RedeemActions';
import RedeemStore from '../../stores/RedeemStore';
import {withRouter} from 'react-router';
import SuccessStage from '../../components/redeem/SuccessStage';
import {connectToStores} from 'epic-alt-utils';
import queryString from 'query-string';

/**
 * RedeemSuccessView.
 *
 * Rendered when the Route matches /redeem/confirmation
 */
@connectToStores
class RedeemSuccessView extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    redeemStore: PropTypes.object,
    macDownloadUrl: PropTypes.string, //eslint-disable-line
    pcDownloadUrl: PropTypes.string, //eslint-disable-line
    supportedOS: PropTypes.array, //eslint-disable-line
    isLoggedIn: PropTypes.bool,
  };

  static getStores() {
    return [RedeemStore];
  }

  static getPropsFromStores() {
    return {
      redeemStore: RedeemStore.getState(),
    };
  }

  static getInitialActions() {
    return [
      (props) => {
        if (props.redeemStore.redeemComplete) {
          RedeemActions.clearEntitlementsFromSession.defer();
        }
      },
    ];
  }

  render() {
    let redeemSuccessViewContent = null;
    const {isLoggedIn} = this.props;
    if (!isLoggedIn) {
      const code = this.props.location.search
        ? queryString.parse(this.props.location.search).code || ''
        : '';
      const loginPath = `${this.props.location.pathname}?code=${code}`;
      redeemSuccessViewContent = <LoginRequired returnPath={loginPath} signupDisabled />;
    } else {
      redeemSuccessViewContent = <SuccessStage {...this.props} />;
    }
    return <div className="redeemView">{redeemSuccessViewContent}</div>;
  }
}

export default withRouter(RedeemSuccessView);
